export default {
    title: 'A new version of athlisis is out',
    reload: 'Refresh',
}
